/**
 * Talala API Docs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ProductInfo } from './productInfo';
import { OfferAmount } from './offerAmount';
import { OfferImage } from './offerImage';
import { OfferPrice } from './offerPrice';


export interface Offer { 
    id?: string;
    price?: OfferPrice;
    /**
     * Amount of items in the offer. For limited offers only
     */
    count?: number | null;
    /**
     * Short name of the product
     */
    title?: string;
    /**
     * Secondary short name of the product, used for list views
     */
    summary?: string;
    /**
     * Full description of the product. Can contain Markdown
     */
    description?: string | null;
    image?: OfferImage;
    /**
     * Offer expiration date
     */
    expires_at?: string | null;
    product?: ProductInfo;
    reward?: OfferAmount;
}

